// Ð¡Ð¾Ð±ÑÑÐ¸Ñ Ð¾Ð±ÑÑÐµÐ½Ð¸Ñ.
//
// Ð¡Ð²Ð¾ÐµÐ¹ ÑÐ¸ÑÑÐµÐ¼Ñ ÑÐ¾Ð±ÑÑÐ¸Ð¹ Ð½Ð° ÑÑÐ¾Ð½ÑÐµ Ð½ÐµÑ, Ð¿Ð¾Ð´ÐºÐ»ÑÑÑÐ½ ÑÐ¾Ð»ÑÐºÐ¾ LogRocket â ÑÑÐ´Ð° Ð¸
// Ð¿Ð¸ÑÐµÐ¼, ÑÑÐ¾Ð±Ñ Ð·Ð°Ð¿Ð¸ÑÑ ÑÐµÑÑÐ¸Ð¸ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð½Ð°Ð¹ÑÐ¸ Ð¿Ð¾ ÑÐ¾Ð±ÑÑÐ¸Ñ. ÐÐ°Ð¾Ð´Ð½Ð¾ ÑÐ»ÑÐ¼ ÑÐ¾Ð±ÑÑÐ¸Ðµ
// Ð² window.dataLayer, ÐµÑÐ»Ð¸ Ð¾Ð½ ÐºÐ¾Ð³Ð´Ð°-Ð½Ð¸Ð±ÑÐ´Ñ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ: ÑÐ°Ðº Ð¿Ð¾Ð´ÐºÐ»ÑÑÐ¸ÑÑ Ð»ÑÐ±ÑÑ
// Ð°Ð½Ð°Ð»Ð¸ÑÐ¸ÐºÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ´ÐµÑ Ð±ÐµÐ· Ð¿ÑÐ°Ð²Ð¾Ðº Ð·Ð´ÐµÑÑ.
//
// ÐÑÐ»Ð¸ ÑÐ¾Ð±ÑÑÐ¸Ñ Ð¿Ð¾Ð½Ð°Ð´Ð¾Ð±ÑÑÑÑ Ð½Ð° Ð±ÑÐºÐµ (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ, ÑÑÐ¸ÑÐ°ÑÑ, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ¾Ð²
// Ð´Ð¾ÑÐ»Ð¾ Ð´Ð¾ ÐºÐ¾Ð½ÑÐ°), Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐ¹ÑÐµ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÑ Ð² Ð¾Ð´Ð½Ð¾Ð¼ ÑÑÐ¾Ð¼ ÑÐ°Ð¹Ð»Ðµ.

import LogRocket from 'logrocket';

export const ONBOARDING_EVENTS = {
  tourStarted: 'onboarding_tour_started',
  tourStepShown: 'onboarding_tour_step_shown',
  tourSkipped: 'onboarding_tour_skipped',
  tourFinished: 'onboarding_tour_finished',
  checklistItemDone: 'onboarding_checklist_item_done',
  checklistHidden: 'onboarding_checklist_hidden',
};

export const trackOnboarding = (event, payload = {}) => {
  try {
    if (LogRocket && typeof LogRocket.track === 'function') {
      LogRocket.track(event, payload);
    }
  } catch (e) {
    // ÐÐ½Ð°Ð»Ð¸ÑÐ¸ÐºÐ° Ð½Ðµ Ð´Ð¾Ð»Ð¶Ð½Ð° Ð¼ÐµÑÐ°ÑÑ ÑÐ°Ð±Ð¾ÑÐµ: Ð¼Ð¾Ð»ÑÐ° Ð¿ÑÐ¾Ð¿ÑÑÐºÐ°ÐµÐ¼.
  }

  try {
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...payload });
    }
  } catch (e) {
    // Ð¢Ð¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ.
  }
};
